import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { Users } from "lucide-react";

const FamilyDeals = () => {
  const { t } = useLang();
  const [deals, setDeals] = useState([]);
  const [restaurants, setRestaurants] = useState({});

  useEffect(() => {
    api.get("/menu-items", { params: { is_family_deal: true } }).then(async (r) => {
      setDeals(r.data);
      const ids = [...new Set(r.data.map(d => d.restaurant_id))];
      const rMap = {};
      await Promise.all(ids.map(async id => {
        try { const res = await api.get(`/restaurants/${id}`); rMap[id] = res.data; } catch {}
      }));
      setRestaurants(rMap);
    });
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-12">
      <div className="bg-coral/10 rounded-3xl p-8 lg:p-12 mb-10 relative overflow-hidden">
        <Users className="absolute right-6 top-6 w-24 h-24 text-coral/20" />
        <div className="relative">
          <h1 className="font-heading text-3xl sm:text-5xl font-extrabold text-navy tracking-tight">{t("familyDeals")}</h1>
          <p className="mt-3 text-navy/70 max-w-lg">Perfect meals for the whole family — great value bundles designed for holidaymakers.</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {deals.map((d, i) => {
          const rest = restaurants[d.restaurant_id];
          return (
            <Link
              key={d.id}
              to={rest ? `/restaurant/${rest.id}` : "/restaurants"}
              data-testid={`family-deal-${d.id}`}
              className="bg-white rounded-2xl overflow-hidden border border-navy/8 card-hover animate-fade-up"
              style={{ animationDelay: `${i * 50}ms` }}
            >
              {d.image && <img src={d.image} alt={d.name} className="w-full aspect-[16/10] object-cover" />}
              <div className="p-4">
                <div className="text-xs text-coral font-bold uppercase tracking-wider">{rest?.name || "Restaurant"}</div>
                <h3 className="font-heading font-bold text-navy text-lg mt-1">{d.name}</h3>
                <p className="text-sm text-navy/60 mt-1">{d.description}</p>
                <div className="mt-3 flex items-center justify-between">
                  <span className="font-heading font-bold text-navy text-2xl">€{d.price.toFixed(2)}</span>
                  <span className="text-xs text-navy/50">View menu →</span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
      {deals.length === 0 && <p className="text-center text-navy/50 py-16">No family deals available yet.</p>}
    </div>
  );
};

export default FamilyDeals;
